import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { type Application } from '../../shared/types';
import { getAdminApplications, getAdvisory } from '../utilities/api';

type AdvisoryStatus = {
    color: 'green' | 'yellow' | 'red';
    details?: string[];
};

export type AdvisoryResult = {
    asOf: string;
    station: { name: string; description: string; latitude: number; longitude: number };
    status: Record<string, AdvisoryStatus>;
};

export const queryKeys = {
    getApplications: () => ['applications', 'get'],
    getAdvisory: (id: string) => ['advisory', 'get', id],
};

export const useApplications = (): UseQueryResult<Application[], Error> => {
    return useQuery({ queryKey: queryKeys.getApplications(), queryFn: getAdminApplications, staleTime: Infinity });
};

export const useAdvisory = (id: string | null): UseQueryResult<AdvisoryResult[], Error> => {
    return useQuery({
        queryKey: queryKeys.getAdvisory(id || ''),
        queryFn: () => getAdvisory(id!),
        enabled: !!id,
    });
};
